import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import CuponRequestLists from "../../components/cupon-requests/CuponRequestLists";

const CuponRequests = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  return <CuponRequestLists userInfoData={userInfoData} />;
};

export default CuponRequests;
